const CREATED_AT_NEWEST = {
	label: 'Newest',
	selectVal: 'latest',
	value: {
		sort_by: 'createdAt',
		order: 'desc',
	},
};
const CREATED_AT_OLDEST = {
	label: 'Oldest',
	selectVal: 'oldest',
	value: {
		sort_by: 'createdAt',
		order: 'ascend',
	},
};

//Defaults
const POSorters = [CREATED_AT_NEWEST, CREATED_AT_OLDEST];

export default POSorters;
